module.exports = __webpack_public_path__ + "assets/img/block-left-bfd95de4.png";